import Nullstack from 'nullstack';
export default function IconRating16Plus({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-rating-16-plus",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "12",
    r: "9"
  }), "   ", Nullstack.element("circle", {
    cx: "11.5",
    cy: "13.5",
    r: "1.5"
  }), "   ", Nullstack.element("path", {
    d: "M7 15v-6"
  }), "   ", Nullstack.element("path", {
    d: "M15.5 12h3"
  }), "   ", Nullstack.element("path", {
    d: "M17 10.5v3"
  }), "   ", Nullstack.element("path", {
    d: "M10 13.5v-3a1.5 1.5 0 0 1 1.5 -1.5h1"
  }), " ");
}